import { Button, Col, Form, Modal, Row, Tag, Upload, message } from 'antd';
import React, { useState } from 'react'
import { Notification, camelCaseString, dataToFormDataConverter } from '../../../../config/Global';
import { CONSTANT } from '../../../../config/Constant';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { UploadOutlined } from '@ant-design/icons';

const AskReason: React.FC<any> = ({ visible, closeReasonModal, fileList, setFileList, setVisible }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();
    const authToken = localStorage.getItem('token');

    var myHeaders = new Headers();
    myHeaders.append('Authorization', authToken ? authToken : '');

    const handleSubmit = async (data: any) => {
        setLoading(true)
        const formData = dataToFormDataConverter(data);
        if (fileList.length > 0) {
            formData.append('file', fileList[0]?.originFileObj);
        }
        formData.append('supportId', visible._id);
        formData.append('ProviderId', visible.ProviderId);
        formData.append('userId', visible.userId);
        try {
            const response = await fetch(`${CONSTANT.BASE_URL}/emailSupport/email-support-ask-reason`, {
                method: 'POST',
                body: formData,
                headers: myHeaders,
            });

            if (response.ok) {
                // console.log('File uploaded successfully!');
                Notification.success({
                    message: 'File uploaded successfully.',
                });
                setLoading(false);
                setVisible(false)
            } else {
                setLoading(false);
                // console.log('File upload failed......');
                Notification.error({
                    message: 'Email send failed',
                });
            }
            form.resetFields();
        } catch (error) {
            setLoading(false);
            // console.log('File upload failed.');
            console.error('Error uploading file:', error);
            Notification.error({
                message: 'File upload failed.',
            });
        }
    }
    const beforeUpload = (file: any) => {
        const isLt10MB = file.size / 1024 / 1024 <= 10;
        if (!isLt10MB) {
            message.error(`${file.name} is larger than 10MB`);
            return Upload.LIST_IGNORE;
        }
        const acceptedFileTypes = [
            'image/jpeg', 'image/png', 'application/pdf', 'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.presentation', 'application/zip', 'image/jpg'
        ];

        if (!acceptedFileTypes.includes(file.type)) {
            message.error(`${file.name} is not a valid file type`);
            return Upload.LIST_IGNORE;
        }
        return isLt10MB;
    };

    const close = () => {
        closeReasonModal()
        form.resetFields();
    }

    const handleFileChange = ({ fileList }: any) => {
        setFileList(fileList);
        form.setFieldsValue({ file: fileList.length ? fileList : null });
    };
    const handleChange = () => {
        form
            .validateFields()
            .then(() => {
                // setDisable(false);
            })
            .catch((error: any) => {
                // setDisable(true);
            });
    };

    return (
        <Modal
            className='addModal'
            title={`Ask Reason!`}
            open={visible}
            onCancel={close}
            footer={false}
            zIndex={1001}
        >
            <FormBox
                className='filterForm'
                form={form}
                onFinish={handleSubmit}
                onChange={handleChange}
                validateTrigger={['onBlur', 'onInput']}
                id='askReason'
            >
                <Row gutter={30}>
                    <Col span={12} style={{ marginBottom: "10px" }}>
                        <label>Status : </label><span>
                            {
                                // visible.status === "in progress" || visible.status === "Pending" ?
                                //     <Tag color="processing" >{visible.status}</Tag> :
                                //     (visible.status === "completed") ?
                                //         <Tag color="success" >{visible.status}</Tag> :
                                //         <Tag color="error" >{visible.status}</Tag>
                                <Tag
                                    color={
                                        (visible.status === "in progress" || visible.status === "Pending") ? "processing"
                                            : visible.status === "completed" ? "success"
                                                : "error"
                                    }
                                >
                                    {visible?.status && camelCaseString(visible.status)}
                                </Tag>
                            }
                        </span>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="file"
                            label="Upload File"
                        >
                            <Upload
                                beforeUpload={beforeUpload}
                                maxCount={1}
                                onChange={handleFileChange}
                                listType="text"
                                accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.odt,.ods,.odp,.zip"
                            >
                                <Button icon={<UploadOutlined />}>Upload File</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                    <InputBox.Text
                        hidden
                        initialValue={visible.status}
                        name="status"
                    />
                    <Col span={24}>
                        <InputBox.TextArea
                            required
                            name={"reason"}
                            placeholder='Ask Reason'
                            label="Ask Reason"
                            rows={1}
                            rules={[
                                validations.required.text('Ask Reason'),
                            ]}
                        />
                    </Col>

                </Row>
                <Row gutter={30}>
                    <Col span={8}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Submit
                        </Button>
                    </Col>
                    <Col span={8}>
                        <Button
                            type="default"
                            onClick={() => {
                                close();
                            }}
                        >
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </FormBox>
        </Modal>
    )
}

export default AskReason